import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'boels-limit-hint',
  templateUrl: './limit-hint.component.html',
  styleUrls: ['./limit-hint.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class LimitHintComponent {
  @ViewChild('charIndicator') charIndicator!: ElementRef;
  @Input() maxLength: number;
  @Input() set valueLength(value: number | undefined) {
    if (!value) {
      this._valueLength = 0;
      return;
    }
    this._valueLength = value;
  }

  _valueLength = 0;
  onFocus() {
    if (this.maxLength && this.charIndicator) {
      this.charIndicator.nativeElement.hidden = false;
    }
  }

  onBlur() {
    if (this.charIndicator) {
      this.charIndicator.nativeElement.hidden = true;
    }
  }
}
